import { render } from "./ViewDashboardVariantOutlineIcon.vue?vue&type=template&id=aa8d6580"
import script from "./ViewDashboardVariantOutlineIcon.vue?vue&type=script&lang=js"
export * from "./ViewDashboardVariantOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__